import { Row } from '@microfrontends/react-components'
import styled from 'styled-components'

export const CompanyPageContainer = styled.div`
    padding: 24px;
    border-radius: 12px;
    overflow: hidden;
    background-color: #fff;
    @media (max-width: 768px) {
        padding: 0;
        display: flex;
        flex-direction: column;
        gap: 8px;
        background-color: unset;
    }
`

export const BreadcrumbStyle = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
    padding: 8px;
`

export const EmptyDiv = styled.div`
    background-color: #f6f8fb;
    border-radius: 6px;
    padding: 80px 40px;
    text-align: center;
    margin-top: 24px;
    p {
        font-size: 14px;
        line-height: 16px;
        color: #777;
        margin: 17px 0 0 0;
    }
    @media (max-width: 768px) {
        svg {
            width: 100%;
        }
    }
`

// Define a wrapper component
export const Wrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`

// Define two child divs with 50% width and 360px height
export const ChildCol = styled.div`
    flex: 1; /* Each child takes up 50% of the available space */
    display: flex;
    flex-direction: column;
`

export const MapWrapper = styled.div`
    flex-grow: 1;
    @media (max-width: 768px) {
        height: 240px;
    }
`

export const LoadingWrapper = styled.div`
    position: relative;
`

export const MainTopDetector = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    user-select: none;
    pointer-events: none;
    height: 50vh;
    @media (min-width: 992px) {
        width: 100%;
        padding: 16px;
    }
    @media (min-width: 1200px) {
        max-width: 1170px;
    }
`

export const ContentWithBordered = styled(Row)`
    border-radius: 12px;
`
